// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--27dfc","text":"_93444fe79c--text--3XpNZ"};